import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        userIds: '=',
        showNavigationError: '=',
        showAddButton: '=',
        enableAll: '=',
        customOptions: '=',
        apgView: '<'
    },
    template: `
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div ng-if="!vm.list.loading && vm.list.items.length">
            <pagination-tools list="vm.list" enable-all="vm.enableAll" custom-options="vm.customOptions"></pagination-tools>
            <table class="data01"
                datatable dt-options="vm.DATATABLES"
                ng-init="vm.initBulk()">
                <thead>
                    <tr>
                        <th><input ng-model="vm.checked" ng-click="vm.toggleAll()" type="checkbox"></th>
                        <th>{{ 'employee.Name' | translate }}</th>
                        <th>{{ 'planning.Position' | translate }}</th>
                        <th>{{ 'planning.Previous date completed' | translate }}</th>
                        <th>{{ 'planning.Previously completed version' | translate }}</th>
                        <th>{{ 'planning.Personal deadline' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td><input
                            type="checkbox"
                            ng-checked="vm.hasUserId(item.userId)"
                            ng-click="$event.stopPropagation();vm.toggleUserId(item.userId)"
                        ></td>
                        <td>
                            {{ item.displayName }}
                            <span ng-if="item.hasOptionalTarget" class="badge"> {{ 'occurrence.Optional target' | translate }} </span>
                            <span ng-if="item.planningGroups.length && vm.hasStartedApg(item)" class="badge round badge-positive" uib-tooltip="{{ vm.startedApgToolTip }}">A</span>
                            <span ng-if="item.planningGroups.length && !vm.hasStartedApg(item)" class="badge round badge-warn" uib-tooltip="{{ vm.apgToolTip }}">A</span>
                        </td>
                        <td>
                            <drl-partial-table drls="item.drls"></drl-partial-table>
                        </td>
                        <td>{{ item.previousPassedTime ? vm.MomentService.formatDate(item.previousPassedTime) : '-' }}</td>
                        <td>{{ item.previouslyCompletedVersion || '-' }}</td>
                        <td ng-bind-html="item.deadline | personalDeadline: item.previousPassedTime:item.isInfiniteDeadline"></td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, MomentService, DATATABLES, AUTOMATED_PLANNING_GROUP_STATUS_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.MomentService = MomentService;
        this.DATATABLES = DATATABLES;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
    }

    $onInit () {
        this.startedApgToolTip = this.$translate.instant('planning.Added to started automated planning group');
        this.apgToolTip = this.$translate.instant('planning.Added to automated planning group');
    }

    initBulk () {
        this.checked = false;
        this.userIds = [];
        this.updateShowAddButton();
    }

    toggleAll () {
        this.userIds = this.checked ? this.list.items
            .filter((user) => !user.apgStatus || user.apgStatus !== this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STARTED)
            .map((user) => user.userId) : [];
        this.updateShowAddButton();
    }

    toggleUserId (id) {
        if (this.hasUserId(id)) {
            this.lodash.pull(this.userIds, id);
            this.checked = false;
        }
        else {
            this.userIds.push(id);
        }

        this.updateShowAddButton();
    }

    hasUserId (id) {
        return this.lodash.includes(this.userIds, id);
    }

    updateShowAddButton () {
        this.showAddButton = this.userIds.length > 0;
        if (!this.showAddButton) {
            this.showNavigationError = false;
        }
    }

    hasStartedApg (item) {
        return item.planningGroups.find((planningGroup) => planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STARTED);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/employee/table/index.js